import classNames from "../../../__snowpack__/pkg/classnames.js";
import React from "../../../__snowpack__/pkg/react.js";
import GnAlert from "../GnAlert/index.js";
import {ScrollTopButton} from "../ScrollTopButton.js";
import Content from "./Content.js";
import Footer from "./Footer.js";
import Header from "./Header.js";
import "./index.css";
import Tabs from "./Tabs.js";
export default function PageContainer(props) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, props?.tipMessage && /* @__PURE__ */ React.createElement("div", {
    style: {margin: 16, marginBottom: -16}
  }, /* @__PURE__ */ React.createElement(GnAlert, {
    message: props?.tipMessage,
    showIcon: true,
    closable: true
  })), /* @__PURE__ */ React.createElement("div", {
    ...props,
    className: classNames("page-container", props.className)
  }, props.children, /* @__PURE__ */ React.createElement(ScrollTopButton, null)));
}
PageContainer.Tabs = Tabs;
PageContainer.TabPane = Tabs.TabPane;
PageContainer.Content = Content;
PageContainer.Header = Header;
PageContainer.Footer = Footer;
